module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACQSURBVEhL3Y5BDoMwEAPzB7j0m8CJh/VcnlUurQNFssCoye6eMtJI0cqxnJrnU6gZVaYMx13M62osRn0usRrzxzt4jcdbVNiiGVcBL4jwggp5DMFUxisOZ3gm31T2L+rTA2YW+Nqf201lXTx/hsCrpnw4kW+cqYY/v+EAO9jDEa6QMyGElh3wSqUbVco2TUpfIEG9Rfh+6tsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-hive/dark/24.png
// module id = 2142
// module chunks = 2